import { render, staticRenderFns } from "./LoginHistory.vue?vue&type=template&id=65c8935a&scoped=true"
import script from "./LoginHistory.vue?vue&type=script&lang=ts"
export * from "./LoginHistory.vue?vue&type=script&lang=ts"
import style0 from "./LoginHistory.vue?vue&type=style&index=0&id=65c8935a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c8935a",
  null
  
)

export default component.exports